<template>
  <apexchart type="bar" :options="chartOptions" :series="series"></apexchart>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },

  data: () => ({
    session: "",

    series: [
      {
        data: [],
      },
    ],

    chartOptions: {},
  }),

  async mounted() {
    this.session = await JSON.parse(Cookie.dec(Cookie.get("myCookie")));
    this.getData();
  },

  methods: {
    getData() {
      this.axios
        .get(process.env.VUE_APP_API + "relawan/usia", {
          headers: {
            Authorization: "Bearer " + this.session.token,
          },
        })
        .then((res) => {
          let label = res.data.data.map((row) => row.umur);

          this.chartOptions = {
            chart: {
              type: "bar",
              height: 350,
              // events: {
              //   click: function (event, chartContext, opts) {
              //     console.log(opts)
              //     console.log(opts.config.series[opts.seriesIndex].name);
              //     console.log(
              //       opts.config.series[opts.seriesIndex].data[
              //         opts.dataPointIndex
              //       ]
              //     );
              //   },
              // },
            },

            plotOptions: {
              bar: {
                borderRadius: 4,
                borderRadiusApplication: "end",
                horizontal: true,
              },
            },

            dataLabels: {
              enabled: false,
            },

            xaxis: {
              categories: label,
            },
          };

          this.series = [
            {
              name: "Jumlah",
              data: res.data.data.map((row) => row.jumlah),
            },
          ];
        })
        .catch((error) => {
          console.log(error.response.status);
        });
    },
  },
};
</script>
